import { useState } from "react";
import { Button, inputClass } from "@/components/base";
import CheckInbox from "@/components/CheckInbox";
import { api, errMsg } from "@/lib/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export default function LoginForm({ submitLabel = "Recevoir mon code", testPrefix = "login" }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email.trim())) {
      setError("Entre un email valide.");
      return;
    }
    setError("");
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email: email.trim() });
      setDone(r.data);
    } catch (err) {
      setError(errMsg(err, "L'email n'est pas parti. Réessaie dans un instant."));
    } finally {
      setBusy(false);
    }
  };

  if (done) return <CheckInbox email={email.trim()} wait={done.resend_in || 60} testPrefix={`${testPrefix}-inbox`} />;

  return (
    <form onSubmit={submit} noValidate className="flex flex-col gap-3" data-testid={`${testPrefix}-form`}>
      <input
        className={inputClass}
        type="email"
        inputMode="email"
        autoComplete="email"
        placeholder="Ton email"
        aria-label="Ton email"
        data-testid={`${testPrefix}-email`}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      {error && <p data-testid={`${testPrefix}-error`} className="text-[13px] err-msg text-ink">{error}</p>}
      <Button type="submit" disabled={busy} data-testid={`${testPrefix}-submit`} className="w-full">
        {busy ? "Envoi..." : submitLabel}
      </Button>
    </form>
  );
}
